import {Component, Input}       from '@angular/core';
import {NgbActiveModal}         from "@ng-bootstrap/ng-bootstrap";

import {NewsFeed}               from "../../../../services/news/newsfeed";



@Component({
	selector: 'app-news-view',
	templateUrl: './news-view.component.html',
	styleUrls: ['./news-view.component.css']
})



/**
 * View the stories retrieved by the date query.
 */
export class NewsViewComponent {


	/**
	 * Create the object.
	 *
	 * @param activeModal  This displays the modal edit window.
	 */
	constructor(

		public activeModal: NgbActiveModal

	) {}


	/**
	 * Receive the incoming stories.
	 *
	 * @type {Array} Story list.
	 */
	@Input() stories:NewsFeed[] = [];


	/**
	 * Text for the display heading.
	 */
	@Input() windowTitle: string;

}



// WEBPACK FOOTER //
// ./src/app/articles/feed/news/view/news-view.component.ts